var React = require('react');

function Dimensions (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#2886A2","key":0}),React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M18 6l2 3L9 20l-3-2v8h8l-2-3 11-11 3 2V6z","key":1})]));
}

Dimensions.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Dimensions;

Dimensions.default = Dimensions;
